import React from 'react'
import { SelectPicker } from 'rsuite'
import { TIMEZONE_OFFSETS_MAP } from '@@partner:config/timezones'
import { mapTZMapToItemDataType } from '@@partner:helpers/data-mappers/timezone'

// TODO: maybe some sort of prepack would be useful here?
const timezoneData = mapTZMapToItemDataType(TIMEZONE_OFFSETS_MAP)

export interface ShopTimezoneProps {
  value: number
  onChange: (value: number) => void
}

export default function ShopTimezonePicker ({
  value,
  onChange
}: ShopTimezoneProps) {
  const handleTimezoneChange = (value: any) => {
    onChange(parseInt(value))
  }

  return (
    <SelectPicker
      value={value}
      placeholder="Часовой пояс магазина"
      data={timezoneData}
      cleanable={false}
      onChange={handleTimezoneChange}
      labelKey="label"
      valueKey="value"
    />
  )
}
